import {axiosInstance, BASE_URLS} from "@/src/shared/api";

export const addErrorLog = async (
    body: {
        actionName: string,
        processInstanceId: string,
        message: string, // response.data.message
        requestMethod?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
        requestMessage?: string, // request.data
        statusCode?: 200 | 201 | 204 | 400 | 401 | 403 | 404 | 500 | 0,
        statusText?: string,
    }
) => {
    const response = await axiosInstance.post(`${BASE_URLS.INTEGRATION_LOG}/add-error`, body)
    return response.data
}
